import _ from 'lodash';
import {
  getRequest,
  postRequest,
  deleteRequest
} from '../../Common/network-call';
import { handleTrickyBoolean } from '../../../util/util-common';
import { ALLOWED_FEATURE_KEYS } from '../../../constants/section-constants/common-constants';
import { ALLOWED_ATTENDEE_PROFILE_SOURCE } from '../../../constants/section-constants/source-constant';
import { SCRIPT_URI_ADDON, TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FIELDS,
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import {
  EVENT_SPECIFIC_CHECKING_CASES,
  checkEventSpecificCases
} from '../../../constants/section-constants/event-specific-checks';

export const FETCH_ATTENDEE = 'FETCH_ATTENDEE';
export const OPEN_ATTENDEE_PROFILE = 'OPEN_ATTENDEE_PROFILE';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';
export const MY_BOOKMARKED_USERS = 'MY_BOOKMARKED_USERS';
export const FILTER_LIST_OPEN = 'FILTER_LIST_OPEN';
export const MATCH_ATTENDEE_CATEGORY = 'MATCH_ATTENDEE_CATEGORY';
export const MAIN_ATTENDEE_LIST = 'MAIN_ATTENDEE_LIST';

export const fetchUserChatThread = (session, userid, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND((receiverid=${session.userid})AND(senderid=${userid}))OR((receiverid=${userid})AND(senderid=${session.userid}))`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.chatthread}?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        callback({ success: 1, data: data.resource });
      },
      error => {}
    );
  };
};

export const showBackScreen = value => {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
};

export const fetchBookmarkedUsers = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})ANDtype=user)`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}?filter=(${filter})`;

  return dispatch => {
    dispatch({
      type: MY_BOOKMARKED_USERS,
      payload: {}
    });
    getRequest(
      url,
      session,
      dispatch,
      response => {
        dispatch({
          type: MY_BOOKMARKED_USERS,
          payload: { resource: response.resource }
        });
        callback({ success: 1, resource: response.resource });
      },
      error => {}
    );
  };
};

export const saveUserbookmark = (session, values, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}`;
  let body = {
    resource: values
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const deleteUserBookmark = (session, id, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}/${id}`;

  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const createChatThread = (session, values, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.chatthread}`;
  let body = {
    resource: values
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const openFilterListComponent = value => {
  return dispatch => {
    dispatch({ type: FILTER_LIST_OPEN, payload: value });
  };
};

export const matchAttendeeCategory = (
  session,
  payloadObj = {
    count: 0,
    cates: {},
    sort: 'az'
  },
  callback
) => {
  return dispatch => {
    dispatch({ type: MATCH_ATTENDEE_CATEGORY, payload: payloadObj }); // filter selections
    dispatch(clearAttendeeList());
    dispatch(
      fetchAttendeeByCategoryFilter(session, payloadObj, res => {
        callback(res);
      })
    );
  };
};

export const prepareForFilter = (
  session,
  payloadObj = {
    count: 0,
    cates: {},
    sort: 'az',
    extraIDs: []
  },
  callback
) => {
  if (!_.isEmpty(payloadObj.cates?.interests)) {
    let idsSTRING = _.uniq(payloadObj.cates?.interests).join(',');
    let filter = encodeURI(
      `(eventid=${session.eventid})AND(interestid IN (${idsSTRING}))`
    );
    let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.userinterests}?fields=${FIELDS.userinterests.minInfo}&filter=(${filter})`;
    return dispatch => {
      getRequest(
        url,
        session,
        dispatch,
        response => {
          if (payloadObj?.forDetails) {
            callback({ success: 1, data: response.resource });
            return;
          } else {
            dispatch(
              matchAttendeeCategory(
                session,
                {
                  cates: {
                    ...payloadObj.cates,
                    interests: _.uniq(response?.resource).map(
                      ea => ea?.appuserid
                    )
                  },
                  count: payloadObj.count,
                  sort: payloadObj.sort,
                  extraIDs: payloadObj.extraIDs
                },
                res => {
                  callback(res);
                }
              )
            );
          }
        },
        error => {}
      );
    };
  } else
    return dispatch => {
      dispatch(
        matchAttendeeCategory(session, payloadObj, res => {
          callback(res);
        })
      );
    };
};

export const resetAttendeeCategory = obj => {
  return dispatch => {
    dispatch({ type: MATCH_ATTENDEE_CATEGORY, payload: { count: 0 } });
  };
};

export const fetchAttendeeByCategoryFilter = (
  session,
  payloadObj = { cates: {}, count: 0, sort: 'az', extraIDs: [] },
  callback
) => {
  return dispatch => {
    dispatch(
      getAttendeeList(session, { sort: payloadObj.sort }, result => {
        if (result.success) {
          let data = [];
          _.map(result.res?.resource, attendee => {
            // let matched = false;
            _.map(payloadObj.cates?.groups, cate => {
              if (_.includes(attendee?.usercategory, cate)) data.push(attendee);
            });
            _.map(payloadObj.cates?.interests, cate => {
              if (_.isEqual(attendee?.appuserid, cate)) data.push(attendee);
            });
            _.map(payloadObj.extraIDs, cate => {
              if (_.isEqual(attendee?.appuserid, cate)) data.push(attendee);
            });
          });

          let localArr = _.filter(
            _.uniq(data),
            attendee => !handleTrickyBoolean(attendee?.isinvisible)
          );

          // --- checking for user name for guest user / name initial data population
          _.map(localArr, attendee => {
            let firstName = !_.isEmpty(attendee?.firstname)
              ? attendee?.firstname.trim()
              : 'G';
            let lastName = !_.isEmpty(attendee?.lastname)
              ? attendee?.lastname.trim()
              : 'U';

            attendee.firstname = firstName;
            attendee.lastname = lastName;
          });

          // --- appending filtered list to same attendee list reducer to avoid multiple conditions
          dispatch({
            type: FETCH_ATTENDEE,
            payload: {
              data: localArr,
              count: localArr.length
            }
          });
          callback({
            success: 1,
            data: localArr,
            count: localArr.length
          });
        } else callback({ success: 0, message: result.error });
      })
    );
  };
};

export const fetchAttendeeList = (
  session,
  extra = { ...SCRIPTS.getCommon.attendees.payload },
  callback = null
) => {
  return dispatch => {
    dispatch(
      getAttendeeList(session, extra, result => {
        if (result.success) {
          const res = result.res;

          let localArr = [];

          if (!_.isEmpty(res?.resource)) {
            localArr = _.filter(
              res?.resource,
              attendee => !handleTrickyBoolean(attendee?.isinvisible)
            );

            _.map(localArr, attendee => {
              let firstName = !_.isEmpty(attendee?.firstname)
                ? attendee?.firstname.trim()
                : 'G';
              let lastName = !_.isEmpty(attendee?.lastname)
                ? attendee?.lastname.trim()
                : 'U';

              attendee.firstname = firstName;
              attendee.lastname = lastName;
            });
          }

          // --- Sorting by lastname first for
          if (
            checkEventSpecificCases(
              session?.eventid,
              EVENT_SPECIFIC_CHECKING_CASES.sortAttendeeByLastName
            )
          )
            localArr = _.sortBy(
              localArr,
              ['lastname', 'firstname'],
              ['asc', 'asc']
            );

          let responsePayload = { data: localArr, count: localArr.length ?? 0 };

          dispatch({
            type: FETCH_ATTENDEE,
            payload: responsePayload
          });
          if (result.success)
            dispatch({
              type: MAIN_ATTENDEE_LIST,
              payload: result.res?.resource
            }); // this list will not get effected by search or filter
          callback && callback({ success: 1, ...responsePayload, error: null });
        } else
          callback &&
            callback({ success: 0, data: result.res, error: result.error });
      })
    );
  };
};

const getAttendeeList = (session, extra, callback) => {
  let fetchUrl = `${session?.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.getCommon.attendees.endpoint}`;
  let fetchPayload = !_.isEmpty(extra?.sort)
    ? extra
    : SCRIPTS.getCommon.attendees.payload;

  return dispatch => {
    postRequest(
      fetchUrl,
      fetchPayload,
      session,
      dispatch,
      result => {
        callback({ success: 1, res: result, error: null });
      },
      error => {
        callback({ success: 0, res: null, error });
      }
    );
  };
};

export const searchAttendee = (mainAttendeeList, search = '', callback) => {
  const searchList = _.filter(
    mainAttendeeList,
    attendee =>
      _.includes(_.toLower(attendee?.firstName), _.toLower(search)) ||
      _.includes(_.toLower(attendee?.lastname), _.toLower(search)) ||
      _.includes(_.toLower(attendee?.username), _.toLower(search)) ||
      _.includes(_.toLower(attendee?.email), _.toLower(search)) ||
      _.includes(_.toLower(attendee?.jobtitle), _.toLower(search)) ||
      _.includes(_.toLower(attendee?.institution), _.toLower(search))
  );

  return dispatch => {
    dispatch({
      type: FETCH_ATTENDEE,
      payload: {
        data: searchList,
        count: searchList.length
      }
    });
    callback({
      success: 1,
      data: searchList,
      count: searchList.length,
      currentsearch: searchList
    });
  };
};

export const clearAttendeeList = () => {
  return dispatch => {
    dispatch({ type: FETCH_ATTENDEE, payload: {} });
  };
};

export const fetchAttendeeDetails = (session, ids, callback) => {
  const joinedIds = ids.join(', ');
  if (_.isEmpty(ids) || _.isEmpty(joinedIds)) return dispatch => {};

  const filter = encodeURI(
    `((eventid=${session?.eventid})AND(appuserid IN (${joinedIds})))`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuser}?filter=${filter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      data => {
        callback({ success: 1, data: data.resource, error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};

export const showAttendeeProfile = (
  session = null,
  valueObj,
  source = ALLOWED_FEATURE_KEYS.attendee
) => {
  let payloadValue = { ..._.cloneDeep(valueObj), calledfrom: source };

  return dispatch => {
    // FIXME: Once all sources checked and listed, remove this
    // if (!_.includes(ALLOWED_ATTENDEE_PROFILE_SOURCE, source))
    dispatch(clearAttendeeProfile());

    switch (source) {
      case ALLOWED_FEATURE_KEYS.overview:
      case ALLOWED_FEATURE_KEYS.attendee:
      case ALLOWED_FEATURE_KEYS.exhibitor:
        dispatch({ type: OPEN_ATTENDEE_PROFILE, payload: payloadValue });
        if (session) {
          dispatch(
            fetchAttendeeDetails(session, [valueObj?.value?.appuserid], res => {
              if (res?.success) {
                payloadValue.value = {
                  ..._.cloneDeep(payloadValue?.value),
                  ...res?.data?.[0]
                };
                dispatch({
                  type: OPEN_ATTENDEE_PROFILE,
                  payload: payloadValue
                });
              }
            })
          );
        } else dispatch({ type: OPEN_ATTENDEE_PROFILE, payload: payloadValue });
        break;

      case ALLOWED_FEATURE_KEYS.speaker:
      case ALLOWED_FEATURE_KEYS.scans:
      case 'profile-image':
        if (valueObj?.value?.responses) {
          dispatch({ type: OPEN_ATTENDEE_PROFILE, payload: payloadValue });
          break;
        }
        dispatch({ type: OPEN_ATTENDEE_PROFILE, payload: payloadValue });
        dispatch(
          fetchAttendeeDetails(session, [valueObj?.value?.appuserid], res => {
            if (res?.success) {
              payloadValue.value = {
                ..._.cloneDeep(payloadValue?.value),
                ...res?.data?.[0]
              };
              // dispatch({
              //   type: OPEN_ATTENDEE_PROFILE,
              //   payload: payloadValue
              // });
              dispatch(
                fetchUserChatThread(
                  session,
                  valueObj.value.appuserid,
                  chatRes => {
                    payloadValue.value.chatthread =
                      chatRes?.data?.length > 0 ? chatRes.data : [];
                    dispatch({
                      type: OPEN_ATTENDEE_PROFILE,
                      payload: payloadValue
                    });
                  }
                )
              );
            }
          })
        );
        break;

      case ALLOWED_FEATURE_KEYS.community:
      case ALLOWED_FEATURE_KEYS.gamification:
      case ALLOWED_FEATURE_KEYS.notes:
      case ALLOWED_FEATURE_KEYS.notifications:
      case ALLOWED_FEATURE_KEYS.schedule:
      case ALLOWED_FEATURE_KEYS.message:
        dispatch(
          fetchUserChatThread(session, valueObj.value.appuserid, res => {
            payloadValue.value.chatthread =
              res?.data?.length > 0 ? res.data : [];
            dispatch({ type: OPEN_ATTENDEE_PROFILE, payload: payloadValue });
          })
        );
        break;

      default:
        dispatch({ type: OPEN_ATTENDEE_PROFILE, payload: payloadValue });
        break;
    }
  };
};

export const hideAttendeeProfile = attendeeVal => {
  return dispatch =>
    dispatch({
      type: OPEN_ATTENDEE_PROFILE,
      payload: { ...attendeeVal, show: false }
    });
};

export const clearAttendeeProfile = () => {
  return dispatch =>
    dispatch({
      type: OPEN_ATTENDEE_PROFILE,
      payload: { show: false, value: {} }
    });
};
